const LayerModal = function () {

    const showLayerModal = (el) => {

        let _slm = el.attr('data-showLayerModal'); 

        $('html, body').addClass('no-scroll');
        $('.ico-gtm-whatsapp').fadeOut(100);

        if(el.hasClass('modal-full')) {
            $('.layer-modal').addClass('modal-full');

        }

        $('.tooltip').tooltip({
            trigger : 'hover'
        })
        $('.tooltip').removeClass('show');
                
        $("#"+_slm).wrap('<div class="bg-overlay actived"></div>');
        /* if( !$('.bg-overlay').length ){
            $("#"+_slm).wrap('<div class="bg-overlay actived"></div>');
        } else {
            $('.bg-overlay').fadeIn(200).css('display','flex');
        } */
        
        //if( el.hasClass('as-modal') ) {
            setTimeout(() => {
                $("#"+_slm).addClass('actived');
            }, 300);            
        /* } else {            
            $("#"+_slm).addClass('actived');            
        } */
    }

    const hideLayerModal = (el) => {
        
        $('html, body').removeClass('no-scroll');
        $('.ico-gtm-whatsapp').fadeIn(100);

        if( el.hasClass('as-modal') ) {
            el.closest('.layer-modal').removeClass('actived modal-full');
        } else {
            el.closest('.layer-modal').removeClass('actived');
        }

        //remove bg-overlay
        $('.bg-overlay').fadeOut(200).removeClass('actived');
        el.closest('.layer-modal').unwrap();
    }


    return {

        init : () => {

            //temp - remover!!!!!!
            /* $("#modal-ajax").wrap('<div class="bg-overlay actived"></div>');
            $('.layer-modal').addClass('actived modal-full'); */
            //temp - remover!!!!!!
           
            $(".show-layer-modal").on('click', function() {
                showLayerModal($(this));                
            });

            $(".close-layer-modal").on('click', function() {                
                hideLayerModal($(this));
            })

            //js-modal-acabamento-escolhido
            $(".js-modal-acabamento-escolhido").on('click', function() {
                let valSelectedFinishig     = $(this).attr('data-id-product');
                let valPrice                = $(this).attr('data-price');
                let indexChoosed            = $(this).attr('data-index-escolhido');
                let colorName               = $(this).attr('data-color_name');
                $('.option-colour').removeClass('actived');
                $("#layer-finishing").removeClass('actived');
                $('.bg-overlay').fadeOut(200);
                $("#layer-finishing").unwrap();
                $('input[name=info]').val(colorName);
                $('input[name=color-selected]').val(valSelectedFinishig);
                $('input[name=id_product]').val(valSelectedFinishig);
                $('.product-price-label').html(colorName);
                $('.product-price').html(valPrice);
                $('.option-colour[data-index='+indexChoosed+']').addClass('actived');
            })

        }

    }

}();

export default LayerModal;